import { useState, useEffect } from "react";
import { saveVendor } from "../Api/MerchantMaster";
import { fetchAllVendors } from "../Api/MerchantMaster";

import {
  getAllCountries,
  getRegionsByCountry,
  getDistrictsByRegion,
  getTehsilsByDistrict,
  getCitiesByTehsil,
  getAllCurrencies,
  getCompanyCodesByOrganisation,
} from "../Api/CustomerMaster";
import { fetchResourceByOrgId } from "../Api/InvoiceApi";
import {
  Form,
  Button,
  Row,
  Col,
  Container,
  Accordion,
  AccordionBody,
  AccordionItem,
} from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import "../Styling/vendormaster.css";
import { useNavigate } from "react-router-dom";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/CopyButton.css";
import { FaUser, FaBuilding, FaEllipsisH } from "react-icons/fa";
const VendorMaster = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const userId = userDetails?.userId;
  const organisationId = userDetails?.organisationId || user?.organisationId;
  const [vendorList, setVendorList] = useState([]);

  const [dropdownData, setDropdownData] = useState({
    countries: [],
    currencies: [],
    companyCodes: [],
    regions: [],
    districts: [],
    tehsils: [],
    cities: [],
    resources: [],
  });

  // Replaces the old registeredInGst select — a simple checkbox toggle in UI
  const [showTaxId, setShowTaxId] = useState(false);

  const [vendorData, setVendorData] = useState({
    Organisation_Id: organisationId || "",
    Company_Code: "",
    vendorName: "",
    countryCode: "",
    regionName: "",
    districtName: "",
    tehsilName: "",
    cityName: "",
    registeredForGst: false,
    taxId: "",
    gstno: "",
    pan: "",
    Address1: "",
    Address2: "",
    Address3: "",
    Client_By: "",
    Parent_Account: "",
    Default_TDS_Percent: "",
    Currency: "",
    Payment_Transaction: "",
    Active: "Yes",
    Short_Names: "",
    Salesperson_Code: "",
    Lead_Type: "",
    Lead_Reference: "",
    Current_Account_Manager: "",
    Type: "",
    city_Code: "",
    mobile_countrycode: "",
    mobile_number: "",
    customer_posting_group: "",
    Pincode: "",
    RECO_GL: "",
    vendorType: "",
  });

  const [locationCodes, setLocationCodes] = useState({
    regionCode: "",
    districtCode: "",
    tehsilCode: "",
    cityCode: "",
  });

  // fetch initial dropdowns (countries, currencies, company codes, resources)
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        setLoading(true);
        const [countries, currencies] = await Promise.all([
          getAllCountries(),
          getAllCurrencies(),
        ]);

        setDropdownData((prev) => ({ ...prev, countries, currencies }));

        if (organisationId) {
          try {
            const companyCodes = await getCompanyCodesByOrganisation(
              parseInt(organisationId)
            );
            setDropdownData((prev) => ({ ...prev, companyCodes }));
            if (companyCodes && companyCodes.length > 0) {
              setVendorData((prev) => ({
                ...prev,
                Company_Code: companyCodes[0].companyCode,
              }));
            }
          } catch (err) {
            toast.error("🦄 Failed to load company codes");
          }

          try {
            const resources = await fetchResourceByOrgId(
              parseInt(organisationId)
            );
            setDropdownData((prev) => ({ ...prev, resources }));
          } catch (err) {
            toast.error("🦄 Failed to load resources (salespersons)");
          }
          try {
            const vendors = await fetchAllVendors();
            setVendorList(vendors || []);
          } catch (err) {
            toast.error("🦄 Failed to load vendor list for Parent Account");
          }
        }
      } catch (err) {
        toast.error(`🦄 Error loading dropdowns: ${err?.message || err}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdowns();
  }, [organisationId]);

  // Regions when country changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (vendorData.countryCode) {
        try {
          setLoading(true);
          const regions = await getRegionsByCountry(vendorData.countryCode);
          setDropdownData((prev) => ({ ...prev, regions }));
          setVendorData((prev) => ({
            ...prev,
            regionName: "",
            districtName: "",
            tehsilName: "",
            cityName: "",
            taxId: "",
            gstno: "",
            pan: "",
            registeredForGst:
              prev.countryCode === "IN" ? prev.registeredForGst : false,
          }));
          setLocationCodes({
            regionCode: "",
            districtCode: "",
            tehsilCode: "",
            cityCode: "",
          });
          setDropdownData((prev) => ({
            ...prev,
            districts: [],
            tehsils: [],
            cities: [],
          }));
          setShowTaxId(false);
        } catch (err) {
          toast.error("🦄 Failed to load regions!");
        } finally {
          setLoading(false);
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          regions: [],
          districts: [],
          tehsils: [],
          cities: [],
        }));
        setVendorData((prev) => ({
          ...prev,
          regionName: "",
          districtName: "",
          tehsilName: "",
          cityName: "",
          taxId: "",
          gstno: "",
          pan: "",
          registeredForGst: false,
        }));
        setLocationCodes({
          regionCode: "",
          districtCode: "",
          tehsilCode: "",
          cityCode: "",
        });
        setShowTaxId(false);
      }
    };
    fetchRegions();
  }, [vendorData.countryCode]);

  // districts when region changes
  useEffect(() => {
    const fetchDistricts = async () => {
      if (vendorData.regionName) {
        try {
          const regionCode = vendorData.regionName.split(" - ")[0];
          const districts = await getDistrictsByRegion(regionCode);
          setDropdownData((prev) => ({ ...prev, districts }));
          setVendorData((prev) => ({
            ...prev,
            districtName: "",
            tehsilName: "",
            cityName: "",
          }));
          setLocationCodes((prev) => ({
            ...prev,
            districtCode: "",
            tehsilCode: "",
            cityCode: "",
          }));
          setDropdownData((prev) => ({ ...prev, tehsils: [], cities: [] }));
        } catch (err) {
          toast.error("🦄 Failed to load districts!");
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          districts: [],
          tehsils: [],
          cities: [],
        }));
        setVendorData((prev) => ({
          ...prev,
          districtName: "",
          tehsilName: "",
          cityName: "",
        }));
        setLocationCodes((prev) => ({
          ...prev,
          districtCode: "",
          tehsilCode: "",
          cityCode: "",
        }));
      }
    };
    fetchDistricts();
  }, [vendorData.regionName]);

  // tehsils when district changes
  useEffect(() => {
    const fetchTehsils = async () => {
      if (vendorData.districtName) {
        try {
          const districtCode = vendorData.districtName.split(" - ")[0];
          const tehsils = await getTehsilsByDistrict(districtCode);
          setDropdownData((prev) => ({ ...prev, tehsils }));
          setVendorData((prev) => ({ ...prev, tehsilName: "", cityName: "" }));
          setLocationCodes((prev) => ({
            ...prev,
            tehsilCode: "",
            cityCode: "",
          }));
          setDropdownData((prev) => ({ ...prev, cities: [] }));
        } catch (err) {
          toast.error("🦄 Failed to load tehsils!");
        }
      } else {
        setDropdownData((prev) => ({ ...prev, tehsils: [], cities: [] }));
        setVendorData((prev) => ({ ...prev, tehsilName: "", cityName: "" }));
        setLocationCodes((prev) => ({ ...prev, tehsilCode: "", cityCode: "" }));
      }
    };
    fetchTehsils();
  }, [vendorData.districtName]);

  // cities when tehsil changes
  useEffect(() => {
    const fetchCities = async () => {
      if (vendorData.tehsilName) {
        try {
          const tehsilCode = vendorData.tehsilName.split(" - ")[0];
          const cities = await getCitiesByTehsil(tehsilCode);
          setDropdownData((prev) => ({ ...prev, cities }));
          setVendorData((prev) => ({ ...prev, cityName: "" }));
          setLocationCodes((prev) => ({ ...prev, cityCode: "" }));
        } catch (err) {
          toast.error("🦄 Failed to load cities!");
        }
      } else {
        setDropdownData((prev) => ({ ...prev, cities: [] }));
        setVendorData((prev) => ({ ...prev, cityName: "" }));
        setLocationCodes((prev) => ({ ...prev, cityCode: "" }));
      }
    };
    fetchCities();
  }, [vendorData.tehsilName]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Checkbox for registeredForGst
    if (name === "registeredForGst") {
      const isChecked = type === "checkbox" ? checked : value === "true";
      setVendorData((prev) => ({ ...prev, registeredForGst: isChecked }));
      setShowTaxId(isChecked && vendorData.countryCode === "IN");
      return;
    }

    if (name === "countryCode") {
      if (value !== "IN") {
        setVendorData((prev) => ({
          ...prev,
          registeredForGst: false,
          taxId: "",
          gstno: "",
        }));
        setShowTaxId(false);
      }
    }

    // extract codes from "code - name" selects
    if (name === "regionName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, regionCode: code }));
    } else if (name === "districtName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, districtCode: code }));
    } else if (name === "tehsilName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, tehsilCode: code }));
    } else if (name === "cityName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, cityCode: code }));
    }

    setVendorData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!organisationId) {
      toast.error("🦄 Organisation ID not found");
      return;
    }

    setLoading(true);
    try {
      // Build request to match vendor_master columns
      const requestData = {
        Name: vendorData.vendorName,
        Tax_Id: vendorData.taxId,
        Country_Code: vendorData.countryCode,
        Client_By: vendorData.Client_By,
        Parent_Account: vendorData.Parent_Account,
        Default_TDS_Percent: vendorData.Default_TDS_Percent,
        Currency: vendorData.Currency,
        Payment_Transaction: vendorData.Payment_Transaction,
        Active: vendorData.Active,
        EnteredBy: userId || vendorData.EnteredBy || "",
        Short_Names: vendorData.Short_Names,
        Salesperson_Code: vendorData.Salesperson_Code,
        Lead_Type: vendorData.Lead_Type,
        Lead_Reference: vendorData.Lead_Reference,
        Current_Account_Manager: vendorData.Current_Account_Manager,
        Registered_in_GST: vendorData.registeredForGst ? "Yes" : "No",
        Address1: vendorData.Address1,
        Address2: vendorData.Address2,
        Address3: vendorData.Address3,
        Region_Name: locationCodes.regionCode || vendorData.regionName,
        District_Name: locationCodes.districtCode || vendorData.districtName,
        Tehsil_Name: locationCodes.tehsilCode || vendorData.tehsilName,
        City_Name: locationCodes.cityCode || vendorData.cityName,
        Type: vendorData.vendorType || vendorData.Type,
        city_Code: vendorData.city_Code,
        gstno: vendorData.gstno,
        pan: vendorData.pan,
        mobile_countrycode: vendorData.mobile_countrycode,
        mobile_number: vendorData.mobile_number,
        Organisation_Id: parseInt(organisationId),
        Company_Code: vendorData.Company_Code,
        customer_posting_group: vendorData.customer_posting_group,
        Pincode: vendorData.Pincode,
        RECO_GL: vendorData.RECO_GL,
      };

      const data = await saveVendor(requestData, userId);
      if (data) {
        toast.success(`${data} Vendor Added Successfully`);

        // Navigate to vendor list page after successful submission
        setTimeout(() => {
          navigate("/vendors/list");
        }, 1500);

        // Reset form
        setVendorData({
          Organisation_Id: organisationId,
          Company_Code: dropdownData.companyCodes?.[0]?.companyCode || "",
          vendorName: "",
          countryCode: "",
          regionName: "",
          districtName: "",
          tehsilName: "",
          cityName: "",
          registeredForGst: false,
          taxId: "",
          gstno: "",
          pan: "",
          Address1: "",
          Address2: "",
          Address3: "",
          Client_By: "",
          Parent_Account: "",
          Default_TDS_Percent: "",
          Currency: "",
          Payment_Transaction: "",
          Active: "Ye",
          Short_Names: "",
          Salesperson_Code: "",
          Lead_Type: "",
          Lead_Reference: "",
          Current_Account_Manager: "",
          Type: "",
          city_Code: "",
          mobile_countrycode: "",
          mobile_number: "",
          customer_posting_group: "",
          Pincode: "",
          RECO_GL: "",
          vendorType: "",
        });

        setLocationCodes({
          regionCode: "",
          districtCode: "",
          tehsilCode: "",
          cityCode: "",
        });
        setShowTaxId(false);
      }
    } catch (err) {
      toast.error(`🦄 Error saving vendor: ${err?.message || err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container resource-master-fields">
      <h2
        className="fields-title"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: "2rem", fontWeight: 700 }}>Vendor Master</span>

        <Button
          variant="outline-primary"
          className="btn-copy"
          onClick={() => navigate("/vendors/list")}
          style={{
            whiteSpace: "nowrap",
          }}
        >
          View Vendor List
        </Button>
      </h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <style>{`
          .big-radio .form-check-input { transform: scale(1.35); margin-right: 8px; }
          .fields-container h4 { font-weight: 600; margin-top: 24px; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 1px solid #e9ecef; }
        `}</style>

      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion defaultActiveKey="0" alwaysOpen>
          {/* Company Details */}
          <Accordion.Item eventKey="0">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaBuilding />
                  </div>
                  <span className="details-header-text">Company Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Orgainsation ID · Company Code · ....</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Organisation ID <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="Organisation_Id"
                      value={vendorData.Organisation_Id}
                      readOnly
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code</Form.Label>
                    <Form.Select
                      name="Company_Code"
                      value={vendorData.Company_Code}
                      onChange={handleChange}
                      disabled={!organisationId}
                    >
                      <option value="">Select Company</option>
                      {dropdownData.companyCodes.map((c) => (
                        <option key={c.companyCode} value={c.companyCode}>
                          {c.companyCode} - {c.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Vendor Details */}
          <Accordion.Item eventKey="1">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUser />
                  </div>
                  <span className="details-header-text">Vendor Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Vendor Name · Short Name....</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Vendor Name <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="vendorName"
                      value={vendorData.vendorName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Short Names</Form.Label>
                    <Form.Control
                      type="text"
                      name="Short_Names"
                      value={vendorData.Short_Names}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Vendor Type <span className="text-red">*</span>
                    </Form.Label>
                    <div className="radio-container">
                      <Form.Check
                        inline
                        className="big-radio"
                        label="Manufacturer"
                        name="vendorType"
                        type="radio"
                        id="vendor-manufacturer"
                        value="manufacturer"
                        checked={vendorData.vendorType === "manufacturer"}
                        onChange={handleChange}
                        required
                      />
                      <Form.Check
                        inline
                        className="big-radio"
                        label="Supplier"
                        name="vendorType"
                        type="radio"
                        id="vendor-supplier"
                        value="supplier"
                        checked={vendorData.vendorType === "supplier"}
                        onChange={handleChange}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Country <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="countryCode"
                      value={vendorData.countryCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Country</option>
                      {dropdownData.countries.map((c) => (
                        <option key={c.countryCode} value={c.countryCode}>
                          {c.countryCode} - {c.countryName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region</Form.Label>
                    <Form.Select
                      name="regionName"
                      value={vendorData.regionName}
                      onChange={handleChange}
                      disabled={!vendorData.countryCode}
                    >
                      <option value="">Select Region</option>
                      {dropdownData.regions.map((r) => (
                        <option
                          key={r.regionCode}
                          value={`${r.regionCode} - ${r.regionName}`}
                        >
                          {r.regionCode} - {r.regionName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>District</Form.Label>
                    <Form.Select
                      name="districtName"
                      value={vendorData.districtName}
                      onChange={handleChange}
                      disabled={!vendorData.regionName}
                    >
                      <option value="">Select District</option>
                      {dropdownData.districts.map((d) => (
                        <option
                          key={d.code}
                          value={`${d.code} - ${d.description}`}
                        >
                          {d.code} - {d.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tehsil</Form.Label>
                    <Form.Select
                      name="tehsilName"
                      value={vendorData.tehsilName}
                      onChange={handleChange}
                      disabled={!vendorData.districtName}
                    >
                      <option value="">Select Tehsil</option>
                      {dropdownData.tehsils.map((t) => (
                        <option
                          key={t.code}
                          value={`${t.code} - ${t.description}`}
                        >
                          {t.code} - {t.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Select
                      name="cityName"
                      value={vendorData.cityName}
                      onChange={handleChange}
                      disabled={!vendorData.tehsilName}
                    >
                      <option value="">Select City</option>
                      {dropdownData.cities.map((c) => (
                        <option
                          key={c.code}
                          value={`${c.code} - ${c.description}`}
                        >
                          {c.code} - {c.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* Tax & GST for India */}
              {vendorData.countryCode === "IN" && (
                <>
                  <Row>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <div className="gst-container">
                        <Form.Group className="mb-3">
                          <Form.Check
                            type="checkbox"
                            id="registeredForGst"
                            name="registeredForGst"
                            label="Registered for GST"
                            checked={vendorData.registeredForGst}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </div>
                    </Col>

                    {vendorData.registeredForGst && (
                      <>
                        {/* <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Tax ID</Form.Label>
                              <Form.Control type="text" name="taxId" value={vendorData.taxId} onChange={handleChange} />
                            </Form.Group>
                          </Col> */}

                        <Col md={5}>
                          <Form.Group className="mb-3">
                            <Form.Label>GST No</Form.Label>
                            <Form.Control
                              type="text"
                              name="gstno"
                              value={vendorData.gstno}
                              onChange={handleChange}
                              maxLength={15}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>PAN</Form.Label>
                        <Form.Control
                          type="text"
                          name="pan"
                          value={vendorData.pan}
                          onChange={handleChange}
                          maxLength={10}
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile Country Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="mobile_countrycode"
                          value={vendorData.mobile_countrycode}
                          onChange={handleChange}
                          maxLength={5}
                          placeholder="+91"
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                          type="tel"
                          name="mobile_number"
                          value={vendorData.mobile_number}
                          onChange={handleChange}
                          pattern="[0-9]{10}"
                          title="10 digit mobile"
                          maxLength={10}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Address 1</Form.Label>
                        <Form.Control
                          type="text"
                          name="Address1"
                          value={vendorData.Address1}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Address 2</Form.Label>
                        <Form.Control
                          type="text"
                          name="Address2"
                          value={vendorData.Address2}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Address 3</Form.Label>
                        <Form.Control
                          type="text"
                          name="Address3"
                          value={vendorData.Address3}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Pincode</Form.Label>
                        <Form.Control
                          type="text"
                          name="Pincode"
                          value={vendorData.Pincode}
                          onChange={handleChange}
                          maxLength={10}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>RECO GL</Form.Label>
                        <Form.Control
                          type="text"
                          name="RECO_GL"
                          value={vendorData.RECO_GL}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
            </Accordion.Body>
          </Accordion.Item>

          {/* Other Details */}
          <Accordion.Item eventKey="2">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaEllipsisH />
                  </div>
                  <span className="details-header-text">Other Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Parent Account · Currency · Active ....</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                {/* <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Client By</Form.Label>
                      <Form.Control type="text" name="Client_By" value={vendorData.Client_By} onChange={handleChange} />
                    </Form.Group>
                  </Col> */}

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Parent Account</Form.Label>
                    <Form.Select
                      name="Parent_Account"
                      value={vendorData.Parent_Account}
                      onChange={handleChange}
                      disabled={loading || vendorList.length === 0}
                    >
                      <option value="">Select Parent Account</option>
                      {vendorList.map((vendor) => (
                        <option
                          key={vendor.vendorCode}
                          value={vendor.vendorCode}
                        >
                          {vendor.vendorCode} - {vendor.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Default TDS Percent</Form.Label>
                      <Form.Control type="text" name="Default_TDS_Percent" value={vendorData.Default_TDS_Percent} onChange={handleChange} />
                    </Form.Group>
                  </Col> */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Currency</Form.Label>
                    <Form.Select
                      name="Currency"
                      value={vendorData.Currency}
                      onChange={handleChange}
                    >
                      <option value="">Select Currency</option>
                      {dropdownData.currencies.map((c) => (
                        <option key={c.currencyCode} value={c.currencyCode}>
                          {c.currencyCode} - {c.currencyName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Active</Form.Label>
                    <Form.Select
                      name="Active"
                      value={vendorData.Active}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                {/* <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Payment Transaction</Form.Label>
                      <Form.Control type="text" name="Payment_Transaction" value={vendorData.Payment_Transaction} onChange={handleChange} />
                    </Form.Group>
                  </Col> */}
              </Row>

              <Row>
                {/* <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Salesperson Code</Form.Label>
                      <Form.Select name="Salesperson_Code" value={vendorData.Salesperson_Code} onChange={handleChange}>
                        <option value="">Select Salesperson</option>
                        {dropdownData.resources.map(resource => (
                          <option key={resource.resourceId} value={resource.resourceId}>
                            {resource.resourceId} - {resource.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col> */}

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Current Account Manager</Form.Label>
                    <Form.Select
                      name="Current_Account_Manager"
                      value={vendorData.Current_Account_Manager}
                      onChange={handleChange}
                    >
                      <option value="">Select Account Manager</option>
                      {dropdownData.resources.map((resource) => (
                        <option
                          key={resource.resourceId}
                          value={resource.resourceId}
                        >
                          {resource.resourceId} - {resource.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            type="submit"
            className="fields-submit"
            disabled={loading || !organisationId}
          >
            {loading ? "Saving..." : "Save Vendor"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default VendorMaster;
